export default __webpack_public_path__ + "static/media/image_double_100.0e789a12.svg";